import { useMemo } from "react";
import { Col, Row, Skeleton } from "antd";
import React from "react";
import { JCard } from "../JCard";


interface JSkeletonSliderProps {
    hasTitle?: boolean;
    elements?: number;
}

const JSkeletonSlider: React.FC<JSkeletonSliderProps> = ({hasTitle = false, elements = 3}) => {

    const skeletonCards = useMemo(() => Array.from({ length: elements }, (_, index) => index), []);

    return (
        <div className={'slider-skeleton'}>
            {
                hasTitle &&
                <Row className={'skeleton-title'} justify={'start'}>
                    <Col span={18}>
                        <Skeleton paragraph={{rows: 1}} />
                    </Col>
                </Row>
            }
            <Row gutter={[36, 36]} justify={'center'}>
                {
                    skeletonCards.map((_, i) => (
                        <Col style={{width: 400}} key={i}>
                            <JCard
                                type={'vertical'}
                                headerContent={<Skeleton.Image active={true} style={{width: 400 - 24, height: 250}} />}
                                contentComponent={<Skeleton active />}
                            />
                        </Col>
                    ))
                }
            </Row>
        </div>
    );
}

export {JSkeletonSlider};